import { createAction, props } from '@ngrx/store';
import { MainNavMenuItem } from 'types-unicorn';
import { BnaError } from 'types-unicorn';

export const ToggleSideMenu = createAction(
  '[LayoutComponent] Toggle Side Menu'
);

export const GetMainNavMenuItems = createAction(
  '[@Effect initalizeApp$] Get Main Nav Menu Items'
);

export const GetMainNavMenuItemsSuccess = createAction(
  '[@Effect getMainNavMenuItems$] Get Main Nav Menu Items Success',
  props<{ menuItems: MainNavMenuItem[] }>()
);

export const GetMainNavMenuItemsFailure = createAction(
  '[@Effect getMainNavMenuItems$] Get Main Nav Menu Items Failure',
  props<{ error: BnaError }>()
);

export const ModifyAccessRequestsItemBadge = createAction(
  '[@Effect modifyAccessRequestsItemBadge$] Modify Access Requests Item Badge',
  props<{ pending: number }>()
);

export const ModifyNewResearchProjectsItemBadge = createAction(
  '[@Effect modifyNewResearchProjectsItemBadge$] Modify New Research Projects Item Badge',
  props<{ newProjects: number }>()
);
